import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportContainedBoundariesModal, type ExportContainedBoundariesModalComponentProps,
} from './exportContainedBoundariesModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportContainedBoundaryData: ExportContainedBoundariesModalComponentProps;
  }
}
modalRenderer.register('ExportContainedBoundaryData', ExportContainedBoundariesModal);
